// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDK011ESQ40YLypU2fPzW82gv6oQRW-LAg",
    authDomain: "codeclubsl.firebaseapp.com",
    projectId: "codeclubsl",
    storageBucket: "codeclubsl.appspot.com",
    messagingSenderId: "891462234179",
    appId: "1:891462234179:web:147a78404c70d2da0624f6",
    measurementId: "G-N0NN09PY7F"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };